// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Kbd from "./Kbd.res.js";
import * as Icon from "../images-and-icons/Icon.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Tooltip from "../overlays/Tooltip.res.js";
import * as TextStyle from "./TextStyle.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as CopyButton from "../actions/CopyButton.res.js";
import * as Stylex from "@stylexjs/stylex";
import * as JsxRuntime from "react/jsx-runtime";
function KbdClipboard(props) {
  let value = props.value;
  let __cropValueAt = props.cropValueAt;
  let __size = props.size;
  let __disabled = props.disabled;
  let label = props.label;
  let disabled = __disabled !== undefined ? __disabled : false;
  let size = __size !== undefined ? __size : "normal";
  let cropValueAt = __cropValueAt !== undefined ? __cropValueAt : 6;
  let match = Hover.use(undefined, undefined, undefined);
  let match$1 = CopyButton.use(value, disabled);
  let copy = match$1.copy;
  let copied = match$1.copied;
  let iconSize = size === "normal" ? 14 : 11;
  let labelSize = size === "normal" ? "normal" : "small";
  let displayedValue = cropValueAt > 0 && value.length > cropValueAt ? value.slice(0, cropValueAt) + "..." : value;
  let newrecord = {
    ...{
      className: "alignItems-x6s0dn4 columnGap-xmixu3c display-x78zum5 flexWrap-x1a02dak",
      "data-style-src": "wino-gc:src/resources/typography/KbdClipboard.res.js:15"
    }
  };
  let tmp;
  tmp = label !== undefined && label !== "" ? JsxRuntime.jsx(TextStyle.make, {
    children: label,
    variation: "normal",
    size: labelSize
  }) : null;
  let newrecord$1 = {
    ...{
      className: "alignItems-x6s0dn4 columnGap-x17zd0t2 display-x3nfvp2",
      "data-style-src": "wino-gc:src/resources/typography/KbdClipboard.res.js:21"
    }
  };
  newrecord.children = [tmp, JsxRuntime.jsx(Tooltip.make, {
    children: JsxRuntime.jsx(Touchable.make, {
      children: JsxRuntime.jsx(Kbd.make, {
        children: JsxRuntime.jsxs("span", (newrecord$1.children = [displayedValue, JsxRuntime.jsx(Icon.make, {
          name: match$1.icon,
          fill: "#25243A",
          width: iconSize,
          height: iconSize,
          bold: copied
        })], newrecord$1)),
        hovered: match[1],
        size: size
      }),
      ariaProps: match$1.ariaProps,
      disabled: disabled || copied,
      wrap: false,
      onPress: param => copy(),
      ref: match[0]
    }),
    placement: "top",
    content: JsxRuntime.jsx(Tooltip.Span.make, {
      text: match$1.tooltipText
    }),
    delay: copied ? 0 : 350,
    closeDelay: 0
  })];
  return JsxRuntime.jsxs("div", newrecord);
}
let make = React.memo(KbdClipboard);
export { make };
/* styles Not a pure module */